module.exports = __webpack_public_path__ + "img/flot9.f2ccf172.svg";